import { render } from "./ProfessionalInfo.vue?vue&type=template&id=9f096868&scoped=true"
import script from "./ProfessionalInfo.vue?vue&type=script&lang=js"
export * from "./ProfessionalInfo.vue?vue&type=script&lang=js"

import "./ProfessionalInfo.vue?vue&type=style&index=0&id=9f096868&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f096868"]])

export default __exports__